<template>
    <div>
        <vue-tinymce
            v-model="form.content"
            :setup="setup"
            @change="contentChange"
            :setting="setting" />
    </div>
</template>

<script>
export default {
    props: {
        content: {
            type: String,
            default: ''
        },
        moduleName: {
            type: String,
            default: ''
        }
    },
    data(){
        return {
            form: {
                content: '',
            },
            setting: {
                menubar: "edit view insert format tools table",
                plugins:"link lists image code table colorpicker textcolor wordcount contextmenu media preview",
                toolbar:"bold italic underline | styleselect | fontsizeselect | forecolor backcolor | alignleft aligncenter alignright alignjustify | undo redo | link unlink image media | removeformat preview",
                style_formats: [
                    {
                        title: '行高',
                        items: [
                            {title: '1', block: 'p', styles: {'line-height': '1.0'}},
                            {title: '1.5', block: 'p', styles: {'line-height': '1.5'}},
                            {title: '2', block: 'p', styles: {'line-height': '2'}},
                            {title: '2.5', block: 'p', styles: {'line-height': '2.5'}},
                            {title: '3', block: 'p', styles: {'line-height': '3'}},
                            {title: '3.5', block: 'p', styles: {'line-height': '3.5'}},
                            {title: '4', block: 'p', styles: {'line-height': '4'}}
                        ],
                    }
                ],
                style_formats_merge: true,
                style_formats_autohide: true,
                file_picker_types: 'media',
                file_picker_callback: async (cb, value, meta) => {
                    if (meta.filetype == 'media'){
                        let input = document.createElement('input');
                        input.setAttribute('type', 'file');
                        input.onchange = async () => {
                            let file = input.files[0];//只选取第一个文件。如果要选取全部，后面注意做修改
                            let formData = new FormData();
                            formData.append('upload', file);
                            let res = await this.$api.rUpload('file/upload/video', formData);
                            if(res.status == 1){
                                cb(res.data.url, { title: file.name })
                                input.remove()
                            }
                        }
                        //触发点击
                        input.click();
                    }
                },
                images_upload_handler:async (blobInfo, success,failure)=> {
                    let res = await this.$api.rPost('file/upload/base64image', {
                        file: blobInfo.base64(),
                        module: this.moduleName
                    })
                    if(res.status == 1){
                        success(res.data.url)
                      // 获取当前的 base64 src
                      const base64Src = blobInfo.blobUri();

                      // 使用 TinyMCE API 替换内容中的 base64 图片为 URL
                      const editor = tinymce.activeEditor;
                      if (editor) {
                        const content = editor.getContent();
                        const updatedContent = content.replace(new RegExp(base64Src, 'g'), res.data.url);
                        editor.setContent(updatedContent);
                        this.$emit('success', updatedContent);
                      }
                    } else {
                      failure('图片上传失败');
                    }
                },
                language_url: this.$util.img('/upload/langs/zh-Hans.js'), // 汉化路径
                language: 'zh-Hans',
                height: 500,
                uploadUrl: ''
            }
        }
    },
    mounted(){
        this.uploadUrl =  this.$util.img('/api/agency/file/upload/image');
        this.form.content = this.content
    },
    methods: {
        setup(editor){
        },
        contentChange(){
            this.$emit('success', this.form.content)
        }
    }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Editor.vue